import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/registration', request)
}

export {post}
